import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import style from './styles.module.less';

/**
 * Purchase Order Receive Footer component
 * Displays the footer of the purchase order receive page with save and cancel buttons
 * @param {object} props - Component props
 * @param {() => void} props.onSave - Function to handle save button click
 * @param {() => void} props.onClose - Function to handle close button click
 * @param {boolean} props.disabled - Function to disable save button
 * @returns {JSX.Element} The footer component
 */
export const PurchaseOrderReceiveFooter = ({ onSave, onClose, disabled }) => {
  return (
    <div className={style['right-side']}>
      <Button onClick={onClose} theme={THEME_CONSTANTS.secondary}>
        <FormattedMessage {...messages.cancel} />
      </Button>
      <Button disabled={disabled} onClick={onSave} theme={THEME_CONSTANTS.primary}>
        <FormattedMessage {...messages.save} />
      </Button>
    </div>
  );
};
